"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.deleteConfig = exports.getGroupedConfigurations = exports.publishConfig = exports.toggleCheckout = exports.updateConfiguration = exports.createConfiguration = exports.getConfigById = exports.getConfigurations = void 0;
const zenithApiPrivate_1 = __importDefault(require("../utils/zenithApiPrivate"));
const config_1 = __importDefault(require("../utils/config"));
const constants_1 = require("../constants");
const { zenithConfigApi } = (0, config_1.default)();
const baseURL = `${zenithConfigApi}${constants_1.routes.CONFIGURATIONS}`;
const getConfigurations = ({ configurationId = '', page = undefined, limit = undefined, search = '', filter = {}, onlyTenants = false, onlyApps = false, }) => () => {
    let url = '';
    if (configurationId && configurationId !== '') {
        url = `${baseURL}/${configurationId}`;
    }
    if (page || limit) {
        url = `${baseURL}?page=${page}&limit=${limit}`;
    }
    if (search && search !== '') {
        url = `${baseURL}?page=${page}&limit=${limit}&search=${search}`;
    }
    if (Object.keys(filter).length > 0) {
        url = `${baseURL}?page=${page}&limit=${limit}&search=${search}&filterBy=${JSON.stringify(filter)}`;
    }
    if (onlyTenants) {
        url = `${baseURL}?onlyTenants=true`;
    }
    if (onlyApps) {
        url = `${baseURL}?onlyApps=true`;
    }
    return zenithApiPrivate_1.default.get(url)
        .then((res) => res.data.data);
};
exports.getConfigurations = getConfigurations;
const getConfigById = (configurationId) => () => {
    const url = `${baseURL}/${configurationId}`;
    return zenithApiPrivate_1.default.get(url)
        .then((res) => res.data.data);
};
exports.getConfigById = getConfigById;
const createConfiguration = (newConfig) => (zenithApiPrivate_1.default.post(baseURL, newConfig)
    .then((res) => res.data));
exports.createConfiguration = createConfiguration;
const updateConfiguration = (configData) => (zenithApiPrivate_1.default.post(baseURL, configData)
    .then((res) => res.data));
exports.updateConfiguration = updateConfiguration;
const toggleCheckout = (data) => {
    const { configId, status } = data;
    const url = `${baseURL}/${configId}/checkout`;
    return zenithApiPrivate_1.default.put(url, { status })
        .then((res) => res.data);
};
exports.toggleCheckout = toggleCheckout;
const publishConfig = (data) => {
    const { configId } = data;
    const url = `${baseURL}/${configId}/publish`;
    return zenithApiPrivate_1.default.put(url)
        .then((res) => res.data);
};
exports.publishConfig = publishConfig;
const getGroupedConfigurations = (tenantId, appId, configType, configCode) => {
    const url = (configCode && configCode !== '')
        ? `${baseURL}?tenantId=${tenantId}&appId=${appId}&configType=${configType}&configCode=${configCode}`
        : `${baseURL}?tenantId=${tenantId}&appId=${appId}&configType=${configType}`;
    return zenithApiPrivate_1.default.get(url)
        .then((res) => res.data.data);
};
exports.getGroupedConfigurations = getGroupedConfigurations;
const deleteConfig = (data) => {
    const { configId } = data;
    return zenithApiPrivate_1.default.delete(`${baseURL}/${configId}`)
        .then((res) => res.data.data);
};
exports.deleteConfig = deleteConfig;
